import { useEffect, useState } from "react";
import { getConsent, onConsentChange, PREFS_OPEN_EVENT } from "@/lib/consent/consent";
import { updateConsent } from "@/lib/consent/loader";
import CookieConsentBanner from "./CookieConsentBanner";
import CookiePreferencesModal from "./CookiePreferencesModal";
import { isAppContext } from "@/lib/appContext";

/** Mounts once in App. Shows the banner until a choice exists; the banner
 *  stays mounted while the preferences modal is open (behind the z-50 overlay)
 *  so Radix Dialog can return focus to the "Cookie Preferences" button on close. */
export default function CookieConsent() {
  const [hasStoredChoice, setHasStoredChoice] = useState(() => getConsent() !== null);
  const [prefsOpen, setPrefsOpen] = useState(false);

  useEffect(() => {
    if (isAppContext()) return;
    const open = () => setPrefsOpen(true);
    window.addEventListener(PREFS_OPEN_EVENT, open);
    const off = onConsentChange(() => setHasStoredChoice(true));
    return () => {
      window.removeEventListener(PREFS_OPEN_EVENT, open);
      off();
    };
  }, []);

  if (isAppContext()) return null;

  return (
    <>
      {!hasStoredChoice && (
        <CookieConsentBanner
          onAcceptAll={() => updateConsent(true, true)}
          onRejectAll={() => updateConsent(false, false)}
          onOpenPreferences={() => setPrefsOpen(true)}
        />
      )}
      <CookiePreferencesModal open={prefsOpen} onOpenChange={setPrefsOpen} />
    </>
  );
}
